import Vue from 'vue';
import Vuex from 'vuex';

import slugify from './slugify';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		isHome: true,
		duvidasLoaded: false,
		tituloDuvidas: '',
		duvidas: {},
		categorias: [],
		nomesCategorias: [],
	},
	mutations: {
		isHome(state, payload) {
			state.isHome = payload;
		},
		setDuvidas(state, payload) {
			state.duvidas = {};
			payload.results.map((duvida) => {
				let catSlug = slugify(duvida.categoria.nome);

				if (!state.nomesCategorias.includes(duvida.categoria.nome)) {
					state.categorias.push({ ...duvida.categoria, slug: catSlug });
					state.nomesCategorias.push(duvida.categoria.nome);
				}

				if (!state.duvidas[catSlug]) {
					state.duvidas[catSlug] = [];
				}

				state.duvidas[catSlug].push({
					id: duvida.id,
					texto: duvida.texto,
					titulo: duvida.titulo,
					slug: slugify(duvida.titulo),
					categoria: catSlug,
					categoriaRaw: duvida.categoria.nome,
				});
			});
		},
		setDuvidasTitulo(state, payload) {
			state.tituloDuvidas = payload;
		},
		setLoad(state, payload) {
			state.duvidasLoaded = payload;
		},
	},
	actions: {
		changeHome(context, payload) {
			context.commit('isHome', payload);
		},
		updateDuvidas(context, payload) {
			context.commit('setDuvidas', payload);
		},
		updateLoad(context, payload) {
			context.commit('setLoad', payload);
		},
		updateTituloDúvidas(context, payload) {
			context.commit('setDuvidasTitulo', payload);
		},
	},
	getters: {
		isHome: (state) => {
			return state.isHome;
		},
		duvidas: (state) => {
			return state.duvidas;
		},
		duvidasLoaded: (state) => {
			return state.duvidasLoaded;
		},
		categorias: (state) => {
			return state.categorias;
		},
		tituloDuvidas: (state) => {
			return state.tituloDuvidas;
		},
	},
});
